import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "..";
import service from "../../services/api.service";
import { plainToClass } from "class-transformer";
import { getTenantId } from "@/store/helper";
import { GuidItemModel } from "../models/shared/guidItem";
import { IPAWorkFlowGridViewDTO, PAWorkFlowGridViewModel } from "../models/paWorkFlow/paWorkFlowGridViewDTO";
import { IPAWorkFlowSearchData } from "../models/paWorkFlow/paWorkFlowSearchData";
import { PAWorkFlowStepsModel } from "../models/paWorkFlow/paWorkFlowStepsDTO";
import { Guid } from "guid-typescript";
import { IPAWorkFlowDTO, PAWorkFlowModel } from "../models/paWorkFlow/paWorkFlowDTO";
import { Vue } from "vue-property-decorator";
import { IPAWorkFlowBulkArchiveRequest } from "../models/paWorkFlow/paWorkFlowBulkArchiveRequest";
import { format } from "date-fns";
import _ from "lodash";
let PAWorkFlowsModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    let PAWorkFlowsModule = class PAWorkFlowsModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.apiNode = "pAWorkFlow";
            this.workFlows = [];
            this.steps = [];
            this.totalCount = 0;
            this.status = [];
            this.forms = [];
            this.workFlow = null;
            this.createdOnAsString = "";
            this.cloneWorkFlowName = "";
        }
        async GetWorkFlows(searchData) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, searchData);
            if (data) {
                this.SetWorkFlows(plainToClass(PAWorkFlowGridViewModel, data.workFlows));
                this.SetStatus(plainToClass(GuidItemModel, data.status));
                this.SetTotalCount(data.totalCount);
                return data;
            }
        }
        async GetWorkFlowByDetailById(workFlowId) {
            var url = `${getTenantId()}/${this.apiNode}/${workFlowId}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetWorkFlow(plainToClass(PAWorkFlowModel, data.workFlow));
                this.SetDateTime(data.createdOn);
                return data;
            }
        }
        // Source workflow plus a name no other workflow has ("Copy of X", "Copy of X (2)", ...).
        async GetWorkFlowForClone(workFlowId) {
            var url = `${getTenantId()}/${this.apiNode}/clone-name/${workFlowId}`;
            const [details, cloneName] = await Promise.all([this.GetWorkFlowByDetailById(workFlowId), service.get(url)]);
            this.SetCloneWorkFlowName(cloneName.data?.name ?? "");
            return details;
        }
        async GetDetailsForWorkFlow() {
            var url = `${getTenantId()}/${this.apiNode}/steps-forms`;
            let { data } = await service.get(url);
            if (data) {
                this.SetForms(plainToClass(GuidItemModel, data.forms));
                this.SetSteps(plainToClass(PAWorkFlowStepsModel, data.steps));
                return data;
            }
        }
        async SaveWorkFlow(item) {
            var url = `${getTenantId()}/${this.apiNode}/add`;
            let { data } = await service.post(url, item);
            if (data) {
                return data;
            }
        }
        async UpdateWorkFlow(item) {
            var url = `${getTenantId()}/${this.apiNode}/edit`;
            let { data } = await service.post(url, item);
            if (data) {
                this.SetWorkFlowData(plainToClass(PAWorkFlowGridViewModel, data.workFlow));
                return data;
            }
        }
        async ArchiveOrUnArchiveWorkFlow(payLoad) {
            var url = `${getTenantId()}/${this.apiNode}/archive-unArchive?workFlowId=${payLoad.workFlowId}&isArchive=${payLoad.isArchive}`;
            let { data } = await service.post(url);
            if (data) {
                this.SetWorkFlowStatus({ workFlowId: payLoad.workFlowId, isArchived: payLoad.isArchive });
            }
            return data;
        }
        async BulkArchiveOrUnArchiveWorkFlows(item) {
            var url = `${getTenantId()}/${this.apiNode}/archive-unArchive/bulk`;
            let { data } = await service.post(url, item);
            return data;
        }
        async DeleteWorkFlowById(workFlowId) {
            var url = `${getTenantId()}/${this.apiNode}/delete/${workFlowId}`;
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
        SetDateTime(date) {
            const dateOne = new Date(date);
            const formattedDate = format(dateOne, "MMM dd, yyyy, hh:mmaaa");
            this.createdOnAsString = formattedDate;
        }
        SetWorkFlowStatus(payLoad) {
            const existingIndex = this.workFlows.findIndex((f) => f.id === payLoad.workFlowId);
            if (existingIndex !== -1) {
                Vue.set(this.workFlows[existingIndex], "isArchived", payLoad.isArchived);
            }
        }
        SetWorkFlowData(workFlow) {
            const existingIndex = this.workFlows.findIndex((f) => f.id === workFlow.id);
            if (existingIndex !== -1) {
                Vue.set(this.workFlows, existingIndex, workFlow);
            }
            else {
                this.workFlows.push(workFlow);
            }
            this.workFlows = _.sortBy(this.workFlows, (item) => item.createdOn).reverse();
        }
        SetWorkFlow(workFlow) {
            this.workFlow = workFlow;
        }
        SetCloneWorkFlowName(name) {
            this.cloneWorkFlowName = name;
        }
        SetWorkFlows(workFlows) {
            this.workFlows = workFlows;
        }
        SetSteps(steps) {
            this.steps = steps;
        }
        SetStatus(status) {
            this.status = status;
        }
        SetForms(forms) {
            this.forms = forms;
        }
        SetTotalCount(count) {
            this.totalCount = count;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof IPAWorkFlowSearchData !== "undefined" && IPAWorkFlowSearchData) === "function" ? _a : Object]),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], PAWorkFlowsModule.prototype, "GetWorkFlows", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof Guid !== "undefined" && Guid) === "function" ? _c : Object]),
        __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
    ], PAWorkFlowsModule.prototype, "GetWorkFlowByDetailById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof Guid !== "undefined" && Guid) === "function" ? _e : Object]),
        __metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
    ], PAWorkFlowsModule.prototype, "GetWorkFlowForClone", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
    ], PAWorkFlowsModule.prototype, "GetDetailsForWorkFlow", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_h = typeof IPAWorkFlowDTO !== "undefined" && IPAWorkFlowDTO) === "function" ? _h : Object]),
        __metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
    ], PAWorkFlowsModule.prototype, "SaveWorkFlow", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_k = typeof IPAWorkFlowDTO !== "undefined" && IPAWorkFlowDTO) === "function" ? _k : Object]),
        __metadata("design:returntype", typeof (_l = typeof Promise !== "undefined" && Promise) === "function" ? _l : Object)
    ], PAWorkFlowsModule.prototype, "UpdateWorkFlow", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], PAWorkFlowsModule.prototype, "ArchiveOrUnArchiveWorkFlow", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_m = typeof IPAWorkFlowBulkArchiveRequest !== "undefined" && IPAWorkFlowBulkArchiveRequest) === "function" ? _m : Object]),
        __metadata("design:returntype", Promise)
    ], PAWorkFlowsModule.prototype, "BulkArchiveOrUnArchiveWorkFlows", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_o = typeof Guid !== "undefined" && Guid) === "function" ? _o : Object]),
        __metadata("design:returntype", Promise)
    ], PAWorkFlowsModule.prototype, "DeleteWorkFlowById", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_p = typeof Date !== "undefined" && Date) === "function" ? _p : Object]),
        __metadata("design:returntype", void 0)
    ], PAWorkFlowsModule.prototype, "SetDateTime", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PAWorkFlowsModule.prototype, "SetWorkFlowStatus", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_q = typeof IPAWorkFlowGridViewDTO !== "undefined" && IPAWorkFlowGridViewDTO) === "function" ? _q : Object]),
        __metadata("design:returntype", void 0)
    ], PAWorkFlowsModule.prototype, "SetWorkFlowData", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_r = typeof PAWorkFlowModel !== "undefined" && PAWorkFlowModel) === "function" ? _r : Object]),
        __metadata("design:returntype", void 0)
    ], PAWorkFlowsModule.prototype, "SetWorkFlow", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], PAWorkFlowsModule.prototype, "SetCloneWorkFlowName", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], PAWorkFlowsModule.prototype, "SetWorkFlows", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], PAWorkFlowsModule.prototype, "SetSteps", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], PAWorkFlowsModule.prototype, "SetStatus", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], PAWorkFlowsModule.prototype, "SetForms", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], PAWorkFlowsModule.prototype, "SetTotalCount", null);
    PAWorkFlowsModule = __decorate([
        Module({ dynamic: true, store: store, name: "workFlow", namespaced: true })
    ], PAWorkFlowsModule);
    return PAWorkFlowsModule;
})();
export const PAWorkFlowModule = getModule(PAWorkFlowsModule);
